var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 11.6755,
    height: 23.9996,
    fill: "#7539FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4238,
    width: 12.3241,
    height: 23.9996,
    fill: "#B8B1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4238,
    y: 11.676,
    width: 12.3241,
    height: 12.3241,
    fill: "#DCD8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice04);
export default __webpack_public_path__ + "static/media/price-04.03c9b9406c10323ec5cf2882c9ee30c6.svg";
export { ForwardRef as ReactComponent };